import React from 'react'
import styled from '@emotion/styled'
import { array, bool, number, string } from 'prop-types'

// Import Components
import { PAGE_ONE, Pagination, ResultsList } from '@jelly/components'
import { Link } from '@jelly/ui'

// Styled Components via Emotion
const RiverWrapper = styled.section`
	display: block;
	height: 100%;
	width: 100%;
	margin-top: 2rem;
`
const FlexRow = styled.div`
	align-items: flex-end;
	display: flex;
	flex-direction: column;
	margin-bottom: 1rem;

	${({ theme }) => theme.MQ.M} {
		align-items: baseline;
		flex-direction: row;
		justify-content: space-between;
	}
`
const Title = styled.h2`
	color: ${({ theme }) => theme.hubTemplate.articleTitle};
	width: 100%;
`
const SeeLatestLink = styled(Link)`
	font-size: 1.25rem;
	margin-left: 1rem;
	text-decoration: underline;

	${({ theme }) => theme.MQ.M} {
		width: 200px;
	}
`
const Wrapper = styled.div`
	font-size: 20px;
	position: relative;
	width: 100%;
`

RiverOfLinks.propTypes = {
	isSponsored: bool,
	numberOfPages: number.isRequired,
	page: number.isRequired,
	path: string.isRequired,
	results: array.isRequired,
	tab: string.isRequired,
	title: string.isRequired,
}

/**
 * This is the River of Links that uses the Pagination component
 * Do not show business and featured listing if the hub page is sponsored
 *
 * @param {Boolean} props.isSponsored 	Boolean value based on if the hub page is sponsored
 * @param {Number} props.numberOfPages 	Number of pages to use for pagination
 * @param {Number} props.page 					Current page
 * @param {String} props.path 					The path of the page we are on
 * @param {Array} props.results 				Results to display
 * @param {String} props.tab 						Tab value for swifttype ex: `article|category|question`
 * @param {String} props.title 					Data for section title
 */
export function RiverOfLinks({ isSponsored, numberOfPages, page, path, results, showLatestLink, title }) {
	return (
		<RiverWrapper>
			<FlexRow>
				<Title>{title}</Title>
				{showLatestLink && (
					<SeeLatestLink href="/latest" variant="tertiary">
						See All Latest
					</SeeLatestLink>
				)}
			</FlexRow>
			<Wrapper>
				<ResultsList results={results} showAdUnit={false} showSponsoredAds={!isSponsored} />
			</Wrapper>
			{numberOfPages > PAGE_ONE && results && <Pagination page={page} path={path} lastPage={numberOfPages} />}
		</RiverWrapper>
	)
}
